<template>
  <BaseTemplate :isHide="true">
    <div class="get-card-list">
      <div class="notice">
        <div v-if="hasPhysicalContent" class="text">{{ t('1タップで「発送依頼」') }}</div>
        <div v-if="hasDigitalContent" class="text">{{ t('1タップで「ダウンロード」') }}</div>
        <div class="text two-text">
          {{ t('2タップで「X marketで販売」となります。') }}
        </div>
      </div>
      <!-- <div class="notice text-red">
        {{ t('Xmarketは近日公開致します') }}
      </div> -->
      <div class="leafbox">
        <div class="acquired-card-container">
          <template v-for="acquiredCardItem in paginatedCardList">
            <!-- <SelectCard
              class="select-card"
              :key="acquiredCardItem.history_id"
              :acquiredCardItem="acquiredCardItem"
              :isChecked="selectedCardHistoryIds.includes(String(acquiredCardItem.history_id))"
              :action_type="acquiredCardItem.action_type"
              @handleCardSelect="selectCard(String(acquiredCardItem.history_id), acquiredCardItem.action_type)"
            /> -->
            <SelectCard
              :key="acquiredCardItem.history_id"
              :acquiredCardItem="acquiredCardItem"
              :selectedAction="getSelectedAction(acquiredCardItem.history_id)"
              @handleCardSelect="selectCard"
              :cardType="acquiredCardItem.card_type"
            />
          </template>
        </div>
        <BoxPager
          class="box-pager"
          :totalPageCount="totalPageCount"
          :currentPageCount="currentPage"
          :pages="boxPagerPages"
          @handlePagerClick="handlePageChange"
          @handleSquareBtnClick="handlePageChange"
        />
      </div>
    </div>
    <SelectButtonArea
      v-if="!isShowAddress"
      :returnItemCount="returnItemCount"
      :sendItemCount="sendItemCount"
      :marketItemCount="marketItemCount"
      :returnPointTotal="returnPointTotal"
      :hasDigitalSend="hasDigitalSend"
      :hasPhysicalSend="hasPhysicalSend"
      :hasDigitalContent="hasDigitalContent"
      :hasPhysicalContent="hasPhysicalContent"
      @openConfirm="checkAddress()"
      @decideLater="handleDecideLater"
    />
    <CommonOverlay
      :isGray="true"
      class="overlay_conf"
      v-show="isOpenConfirm"
      @handleOverlayClick="closeOpenConfirm"
    >
      <CommonModal class="modal pack-confirm">
        <div class="block">
          <div>{{ t('最終確認') }}</div>
        </div>
        <div class="block">
          <div>
            {{ t('選択したものでお間違いないでしょうか？') }}
          </div>
        </div>
        <div class="modal-button-area">
          <SimpleButton
            class="purchase-btn"
            :isArrow="false"
            :text="t('はい')"
            @handleSquareBtnClick="saveResult"
          />
          <SimpleButton
            class="purchase-btn cancel-btn"
            :isArrow="false"
            :text="t('キャンセル')"
            @handleSquareBtnClick="isOpenConfirm = false"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
    <CommonOverlay :isGray="true" class="overlay_conf" v-show="isOpenComplete">
      <CommonModal class="modal pack-confirm">
        <div class="block complete_title">
          <div>Thank you</div>
        </div>
        <template v-if="isDecideLater">
          <div class="modal-button-area complete-buttons">
            <SimpleButton
              v-if="currentPack && Number(currentPack.pack_count) > 0"
              class="purchase-btn"
              :isArrow="false"
              :text="t('同じガチャを買う')"
              @handleSquareBtnClick="goReGacha"
            />
            <SimpleButton
              class="purchase-btn"
              :isArrow="false"
              :text="t('TOPページへ')"
              @handleSquareBtnClick="goToTop"
            />
            <BuyButton
              class="purchase-btn"
              :isArrow="false"
              :text="t('景品を確認する')"
              @handleSquareBtnClick="goToUndecided"
            />
          </div>
        </template>
        <template v-else>
          <div class="modal-button-area complete-buttons">
            <SimpleButton
              v-if="currentPack && Number(currentPack.pack_count) > 0"
              class="purchase-btn"
              :isArrow="false"
              :text="t('同じガチャを買う')"
              @handleSquareBtnClick="goReGacha"
            />
            <SimpleButton
              class="purchase-btn"
              :isArrow="false"
              :text="t('Xmarket 出品リスト')"
              @handleSquareBtnClick="goToMarketList"
            />
            <SimpleButton
              class="purchase-btn"
              :isArrow="false"
              :text="t('TOPページへ')"
              @handleSquareBtnClick="goToTop"
            />
            <BuyButton
              class="purchase-btn"
              :isArrow="false"
              :text="t('景品を確認する')"
              @handleSquareBtnClick="hasDigitalContent ? goToDownloaded() : goToUndecided()"
            />
          </div>
        </template>
      </CommonModal>
    </CommonOverlay>
    <AddressPopup
      v-show="isShowAddress"
      @handleClose="isShowAddress = false"
      @handleSuccess="successAddress"
    />
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  separateCharacterNumber,
  parseNumberArrayToStringArray,
} from '@/common/util/format';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import SelectButtonArea from '@/components/organisms/SelectButtonArea.vue';
import SelectCard from '@/components/organisms/SelectCard.vue';
import t from '@/plugins/i18n';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import SimpleButton from '@/components/atoms/SimpleButton.vue';
import BuyButton from '@/components/atoms/BuyButton.vue';
import AddressPopup from '@/components/organisms/AddressPopup.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';

export default {
  name: 'GetProductList',
  mixins: [t],

  components: {
    BaseTemplate,
    SelectCard,
    CommonOverlay,
    CommonModal,
    SimpleButton,
    BuyButton,
    SelectButtonArea,
    AddressPopup,
    BoxPager,
  },

  data: () => ({
    currentPage: 1,
    itemsPerPage: 100,
    selectedSendCardIds: [],
    selectedReturnCardIds: [],
    selectedMarketCardIds: [],
    isOpenConfirm: false,
    isOpenComplete: false,
    isShowAddress: false,
    isDecideLater: false,
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      buyPackResult: 'pack/buyPackResult',
      devidePackCardresult: 'pack/devidePackCardresult',
      currentPack: 'pack/currentPack',
    }),
    getCardList() {
      return this.buyPackResult ? this.buyPackResult.cards : [];
    },
    sendItemCount() {
      return separateCharacterNumber(this.selectedSendCardIds.length);
    },
    returnItemCount() {
      return separateCharacterNumber(this.selectedReturnCardIds.length);
    },
    marketItemCount() {
      return separateCharacterNumber(this.selectedMarketCardIds.length);
    },
    returnPointTotal() {
      return separateCharacterNumber(
        this.getCardList
          .filter((card) => this.selectedReturnCardIds.includes(String(card.history_id)))
          .reduce((total, card) => total + parseInt(card.buy_point, 10), 0),
      );
    },
    hasDigitalContent() {
      return this.getCardList.some((card) => card.is_digital_content);
    },
    hasPhysicalContent() {
      return this.getCardList.some((card) => !card.is_digital_content);
    },
    hasDigitalSend() {
      return this.getCardList.some(
        (card) => card.is_digital_content && this.selectedSendCardIds.includes(String(card.history_id)),
      );
    },
    hasPhysicalSend() {
      return this.getCardList.some(
        (card) => !card.is_digital_content && this.selectedSendCardIds.includes(String(card.history_id)),
      );
    },
    // 総ページ数
    totalPageCount() {
      return Math.ceil(this.getCardList.length / this.itemsPerPage);
    },
    // 表示するカードだけを抽出
    paginatedCardList() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.getCardList.slice(start, start + this.itemsPerPage);
    },
    // BoxPager に渡すページリスト
    boxPagerPages() {
      return Array.from({ length: this.totalPageCount }, (_, i) => i + 1);
    },
  },

  watch: {
    devidePackCardresult(newVal) {
      if (newVal) {
        this.isOpenConfirm = false;
        if (newVal.state === 200 && newVal.result === '1') {
          this.$store.dispatch('pack/clearDevidePackCardResult');
          this.isOpenComplete = true;
        } else if (newVal.state === 204 && newVal.result === '-1') {
          const { count } = newVal.errors;
          alert(count[0]);
        }
      }
    },
    buyPackResult(newVal) {
      if (!this.currentPack) {
        this.$store.dispatch('pack/setCurrentPack', { packId: newVal.pack_id });
      }
    },
  },

  created() {
    this.$store.dispatch('pack/clearCurrentPack');
    if (this.$route.query.c) {
      this.parseSendCardIds();
    }
    this.getCardList.forEach((card) => {
      const cardId = String(card.history_id);
      if (card.action_type === '1') {
        this.selectedReturnCardIds.push(cardId);
      } else if (card.action_type === '2') {
        this.selectedSendCardIds.push(cardId);
      } else if (card.action_type === '3') {
        this.selectedMarketCardIds.push(cardId);
      } else {
        this.selectedReturnCardIds.push(cardId);
      }
    });
    this.$store.dispatch('pack/setBuyPackResult');
    if (this.buyPackResult && !this.currentPack) {
      this.$store.dispatch('pack/setCurrentPack', {
        packId: this.buyPackResult.pack_id,
      });
    }
  },

  methods: {
    parseSendCardIds() {
      const { c } = this.$route.query;
      const cardIds = typeof c === 'string' ? [c] : [...c];
      this.selectedSendCardIds = parseNumberArrayToStringArray(cardIds);
    },
    selectCard(cardId, actionType, selectedAction) {
      // action_type '1', '2', '3' の場合は固定アクションなので変更不可
      if (actionType === '1' || actionType === '2' || actionType === '3') {
        return;
      }
      // action_type '0' と '4' の場合は選択可能
      // action_type '4' の場合はマーケット無効だが、send/returnは選択可能
      this.removeFromAllLists(cardId);
      if (selectedAction === 'send') {
        this.selectedSendCardIds.push(cardId);
      } else if (selectedAction === 'return') {
        this.selectedReturnCardIds.push(cardId);
      } else if (selectedAction === 'market' && actionType === '0') {
        // マーケット選択は action_type '0' の場合のみ
        this.selectedMarketCardIds.push(cardId);
      }
    },

    removeFromAllLists(cardId) {
      this.selectedSendCardIds = this.selectedSendCardIds.filter(
        (id) => id !== cardId,
      );
      this.selectedReturnCardIds = this.selectedReturnCardIds.filter(
        (id) => id !== cardId,
      );
      this.selectedMarketCardIds = this.selectedMarketCardIds.filter(
        (id) => id !== cardId,
      );
    },

    getSelectedAction(cardId) {
      if (this.selectedSendCardIds.includes(cardId)) return 'send';
      if (this.selectedReturnCardIds.includes(cardId)) return 'return';
      if (this.selectedMarketCardIds.includes(cardId)) return 'market';
      return '';
    },
    saveResult() {
      const postParams = {
        send_card: this.selectedSendCardIds,
        reduction_card: this.selectedReturnCardIds,
        market_card: this.selectedMarketCardIds,
      };
      this.$store.dispatch('pack/devidePackCard', { postParams });
    },
    goReGacha() {
      // this.$router.push(`/pack-detail?packId=${this.buyPackResult.pack_id}`);
      // 非公開ガチャの判定
      const isHiddenGacha = this.currentPack.card_hide_flag === 1 && Number(this.currentPack.pack_count) !== 0;
      if (isHiddenGacha) {
        // 非公開ガチャの場合は、TOPページまたはStoreページに遷移してガチャを中央表示
        if (this.buyPackResult.card_type === '13') {
          this.$router.push({
            path: '/store',
            query: {
              cardType: this.buyPackResult.card_type,
              packId: this.buyPackResult.pack_id,
            },
          });
        } else {
          this.$router.push({
            path: '/',
            query: {
              cardType: this.buyPackResult.card_type,
              packId: this.buyPackResult.pack_id,
            },
          });
        }
      } else {
        // 公開ガチャの場合は従来通り詳細ページに遷移
        if (this.buyPackResult.card_type === '13') {
          this.$router.push(`/store-pack-detail?packId=${this.buyPackResult.pack_id}`);
        }
        this.$router.push(`/pack-detail?packId=${this.buyPackResult.pack_id}`);
      }
    },
    goToDownloaded() {
      this.$router.push('/downloaded-detail');
    },
    goToUndecided() {
      this.$router.push('/undecided-detail');
    },
    handleDecideLater() {
      this.isDecideLater = true;
      this.isOpenComplete = true;
    },
    goToMarketList() {
      // TODO
      this.$router.push('/market-mylist-undecided');
    },
    goToTop() {
      // 回していたガチャのカードタイプに遷移
      if (this.buyPackResult && this.buyPackResult.card_type) {
        // shopガチャの場合はstoreページに遷移
        if (this.buyPackResult.card_type === '13') {
          // shop_category_id > 0 の場合はDBから取得したカテゴリIDでタブを指定
          if (Number(this.buyPackResult.shop_category_id) > 0) {
            this.$router.push(`/store?cardType=${this.buyPackResult.shop_category_id}`);
          } else {
            this.$router.push('/store');
          }
        } else {
          // ボーナスパックの場合はボーナスタブ（999995）に遷移
          const cardType = this.buyPackResult.is_bonus === '1' || this.buyPackResult.is_bonus === 1
            ? 999995
            : this.buyPackResult.card_type;
          this.$router.push(`/?cardType=${cardType}`);
        }
      } else {
        this.$router.push('/');
      }
    },
    checkAddress() {
      if (this.buyPackResult.is_address || this.selectedSendCardIds.length === 0) {
        this.isShowAddress = false;
        this.isOpenConfirm = true;
      } else {
        this.isShowAddress = true;
      }
    },
    successAddress() {
      this.isShowAddress = false;
      this.isOpenConfirm = true;
    },
    closeOpenConfirm(event) {
      // 自分自身がクリックされたときだけ
      if (event.target === event.currentTarget) {
        this.isOpenConfirm = false;
      }
    },
    handlePageChange(pageNumber) {
      if (pageNumber !== this.currentPage) {
        this.currentPage = pageNumber;
        // スクロールトップへ
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.notice {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
  border-radius: 10px;
  padding: 10px;
  margin: 20px 0;
  .text {
    text-align: left;
    color: #202288;
    font-weight: bold;
    font-size: 19px;
    @media screen and (max-width: $tabletWidth) {
      font-size: 15px;
    }
    &.two-text {
      color: #ff0000;
    }
  }
}
.get-card-list{
  width: 760px;
  margin: 0 auto;
  text-align: center;
  background-color: initial !important;
  padding: 0 !important;
  @include appendMap($backgroundStyleMap);
  .leafbox {
    max-width: 1000px;
    margin: 20px auto 120px auto;
  }
  .acquired-card-container {
    display: flex;
    position: relative;
    width: 100%;
    margin-top: 20px;
    white-space: nowrap;
    .select-card, .select-card-wrapper{
      display: flex;
      width: 30%;
      margin-top: 20px;
    }
    justify-content: space-around;
    flex-wrap: wrap;
    @media screen and (min-width: $tabletWidth) {
      display: flex;
      overflow: visible;
      margin-top: 10px;
      .select-card, .select-card-wrapper{
        margin-top: 40px;
      }
    }
  }
  .square-button {
    width: 200px;
    height: 40px;
    margin: 25px auto;
  }
}
.box-pager {
  padding-bottom: 280px;
}
.overlay_conf {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  .pack-confirm {
    border-radius: 10px;
    max-width: 600px;
    min-width: 400px;
    padding: 30px;
    position: relative;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
    margin: 0 3%;
    .block {
      padding: 30px 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin: 10px 20px;
      font-weight: bold;
      text-align: center;
      color: $gray2;
      div {
        text-align: center;
      }
    }
    .close_button {
      position: absolute;
      right: 15px;
      top: 15px;
    }
    @media screen and (max-width: $mobileWidth) {
      max-width: 90vw;
      min-width: 320px;
      padding: 40px 20px;
      .block {
        padding: 20px 10px;
      }
    }
  }
  .modal-button-area {
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
    gap: 30px;
    margin-top: 40px;
    .purchase-btn {
      width: 48%;
      @media screen and (max-width: $mobileWidth) {
        width: 100%;
        max-width: 180px;
      }
    }
    @media screen and (max-width: $mobileWidth) {
      flex-direction: column;
      margin: 30px 0;
      align-items: center;
      gap: 30px;
    }
  }
  .top-area {
    margin-top: 15px;
    display: flex;
    justify-content: center;
    .purchase-btn {
      width: 100%;
      max-width: 180px;
      font-size: 14px;
    }
  }
  .complete_title {
    font-size: 24px;
    font-weight: bold;
  }
  .complete-buttons {
    flex-direction: column;
    align-items: center;
    gap: 15px;
    margin-top: 20px;
    .purchase-btn {
      width: 80%;
      max-width: none;
      font-size: 14px;
      padding: 10px 20px;
    }
    @media screen and (max-width: $mobileWidth) {
      .purchase-btn {
        padding: 12px 20px;
        font-size: 15px;
      }
    }
  }
  .bottom-area {
    flex-direction: row;
    gap: 20px;
    .purchase-btn {
      max-width: none;
    }
    @media screen and (max-width: $mobileWidth) {
      flex-direction: column;
      .purchase-btn {
        max-width: 180px;
      }
    }
  }
  .digital-btn {
    padding: 10px 20px;
    font-size: 14px;
    @media screen and (max-width: $mobileWidth) {
      padding: 12px 20px;
      font-size: 15px;
    }
  }
}
@media screen and (max-width: $tabletWidth) {
  .get-card-list {
    // padding: 30px 10px;
    .leafbox {
      // margin: 20px 10px;
      margin: 20px 0;
    }
  }
  .box-pager {
    padding-bottom: 0px;
  }
}
</style>
